import axios from 'axios';
import router from "@/router";


// export const baseURL = process.env.VUE_APP_BASE_URL || "http://49.235.179.198:8080/firstwindow_nj_cs/api";
// export const baseURL = process.env.VUE_APP_BASE_URL || "http://49.235.179.198:8080/firstwindow_nj/api";
export const baseURL = process.env.VUE_APP_BASE_URL || "http://32.1.230.1:7081/firstwindow_nj/api";
export const FrURL = process.env.VUE_APP_FRURL || '/firstwindow_nj_pc_cs/'

const service = axios.create({
  baseURL: baseURL,
  timeout: 1000 * 120,
});

// 添加请求拦截器
service.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  if (config.method === 'post') {

    if (config.useJson) {
      config.headers["Content-Type"] = "application/json;charset=UTF-8";
    } else if (config.useFormData) {
      config.headers["Content-Type"] = "multipart/form-data;";
    } else {
    }

    if( !config.notUseToken ){
      config.url = config.url + '?token=' + localStorage.getItem('tz_token')
    }
  }
  if (config.method === 'get') {
    if( !config.notUseToken ){
      if (config.url.lastIndexOf('?') > -1) {
        config.url = config.url + '&token=' + localStorage.getItem('tz_token')
      } else {
        config.url = config.url + '?token=' + localStorage.getItem('tz_token')
      }
    }
  }
  return config;
}, function (error) {
  // 对请求错误做些什么
  console.log(error, "请求错误");
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(function (response) {
  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  console.log('router',router.currentRoute.value.fullPath  );

let list = [ '/myselflist' ]

  const data = response.data;
  if (data.errorcode == "10003") {
    localStorage.removeItem('yc_userinfo')
    localStorage.removeItem('tz_token')
    router.push("/login")
  }
  if( data.errorcode == '10013' ){
    localStorage.removeItem('self_token')
  }
  if( data.errorcode == '10033' ){
    localStorage.removeItem('self_token')
    router.push("/selflogin")

  }
  return data;
}, function (error) {
  console.log(error)
  // if(error.response.status == 404){
  //     router.push('/404')
  // }
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  return Promise.reject(error);
});


export default service;

